export default __webpack_public_path__ + "static/media/light_dis_bookmark.04977eb5.svg";